import { render, staticRenderFns } from "./ClassroomTeacher.vue?vue&type=template&id=1baf1ec3"
import script from "./ClassroomTeacher.vue?vue&type=script&lang=js"
export * from "./ClassroomTeacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports